import { AxiosInstance, AxiosError } from "axios";
import { BaseApi } from "../base-api";
import {
  ICreateUserRequestModel,
  ICreateUserResponseModel,
  IGetAllProjectsResponseModel,
  IUpdateUserRequestModel,
  IUsersApi,
} from "@lib/types";

export class UsersApi extends BaseApi implements IUsersApi {
  constructor(instance: AxiosInstance) {
    super(instance);
  }

  async create(
    body: ICreateUserRequestModel,
  ): Promise<ICreateUserResponseModel> {
    try {
      const response = await this._instance.post<ICreateUserResponseModel>(
        `web/users`,
        body,
      );
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async update(
    userId: number,
    body: IUpdateUserRequestModel,
  ): Promise<number> {
    try {
      const response = await this._instance.patch(`web/users/${userId}`, body);
      return response.status;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }

  async getProjects(
    userId: number,
  ): Promise<Array<IGetAllProjectsResponseModel>> {
    try {
      const response = await this._instance.get<
        Array<IGetAllProjectsResponseModel>
      >(`/users/${userId}/projects`);
      return response.data;
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        throw error;
      }
      throw new Error("Unknown error");
    }
  }
}
